module.exports = __webpack_public_path__ + "phone_redirect.png?a8950b4bbf15184689602a2e6e8e0492";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone_redirect.png
// module id = 249
// module chunks = 0